module.exports = __webpack_public_path__ + "img/hierarchy-square-2.d6506595.svg";